export const MPAC_CONFIGURATION_KEYS = {
  homePageBanner: 'homePageBanner',
  featuredSection: 'featuredSection'
};